var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('upload',{attrs:{"value":"7205e0b575119e05649719c4119122f7","params":_vm.uploadParams}}),_c('div'),_c('upload',{attrs:{"value":"7205e0b575119e05649719c4119122f7.png","params":_vm.uploadParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }